module.exports = __webpack_public_path__ + "static/img/search_bar_down.047ca3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search_bar_down.svg
// module id = b08f
// module chunks = 1